<template>
  <Drawer
    :id="drawerId"
    title="Add Card"
    padded
    :bottom="bottom"
    @close="show = false"
  >
    <PaymentEntryForm
      mode="setup"
      :showCards="false"
      :returnUrl="returnUrl"
      @success="onSuccess"
    />
  </Drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import Drawer from '../../components/layout/Drawer';
import { APP_EVENTS, DRAWERS, ROUTES } from '../../utils/constants';
import copyObject from '../../utils/copyObject';
import PaymentEntryForm from './PaymentEntryForm';

export default {
  name: 'AddCardDrawer',

  components: {
    Drawer,
    PaymentEntryForm
  },

  data() {
    return {
      drawerId: DRAWERS.ADD_CARD_DRAWER,
      bottom: false
    };
  },

  computed: {
    returnUrl() {
      return this.$store.state.config.dashboardUrl + ROUTES.CARDS.PATH;
    },

    ...mapGetters({
      initialData: 'drawers/data',
      drawerOpenedAt: 'drawers/lastOpenedAt',
      top_drawer: 'drawers/topDrawer'
    })
  },

  watch: {
    drawerOpenedAt(val, oldVal) {
      if (this.drawerId === this.top_drawer?.id) {
        const initial = this.initialData(this.drawerId) || {};
        if (initial && initial.bottom) this.bottom = true;
        else this.bottom = false;
      }
    }
  },

  methods: {
    async onSuccess() {
      var previousCardIds = copyObject(this.$store.state.cards.items.map((x) => x.id));
      await this.$store.dispatch('cards/getAll');
      var currentCardIds = this.$store.state.cards.items.map((x) => x.id);
      var newCardIds = currentCardIds.filter((x) => !previousCardIds.includes(x));
      this.$store.commit('drawers/CLOSE_DRAWER', DRAWERS.ADD_CARD_DRAWER);
      if (newCardIds.length) {
        this.$eventBus.$emit(APP_EVENTS.SET_PAYMENT_METHOD, newCardIds[0]);
      }
    }
  }
};
</script>

<style></style>
